import React, { useCallback, useContext, useEffect, useState } from "react";
import { CoreContainer, Notification } from "../common/style";
import { Card, CardGroup, CatalogsContainer, SearchInput } from "./style";
import { Button, Spinner } from "reactstrap";
import { AppContext } from "../context";
import { useSearchParams } from "react-router-dom";
import { getProducts } from "./service";
import { debounce } from "lodash";
import useSearchParamHandler from "../utils";
import Header from "../common/Header";
import Catalog from "./Catalog";

const Catalogs = () => {
  const { catalogs, catalogsLoading, setCatalogs, setCatalogsLoading } =
    useContext(AppContext);
  const [searchParams] = useSearchParams();
  const replaceSearchParam = useSearchParamHandler();
  const [searchText, setSearchText] = useState("");
  const [notification, setNotification] = useState({ type: "", message: "" });
  const [isNotificationVisible, setIsNotificationVisible] = useState(false);
  const [showMore, setShowMore] = useState({});

  const onDismissNotification = () => {
    setIsNotificationVisible(false);
  };

  const handleSearch = (searchValue) => {
    setSearchText(searchValue);
    debounceSearch(searchValue, searchParams);
  };

  const debouncedSearch = (searchTerm, searchParams) => {
    replaceSearchParam("search", searchTerm, searchParams);
  };

  const debounceSearch = useCallback(debounce(debouncedSearch, 500), []);
  const searchTerm = searchParams.get("search") || "";

  useEffect(() => {
    return () => {
      handleSearch("");
      setCatalogs({});
    };
  }, []);

  useEffect(() => {
    setCatalogsLoading(true);
    setSearchText(searchTerm);

    getProducts({
      searchTerm,
      defaultCatalogs: !searchTerm,
    })
      .then((products) => {
        setCatalogs(products);
        setShowMore(
          Object.keys(products).reduce((acc, value) => {
            acc[value] = false;
            return acc;
          }, {})
        );
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotification({ type: "error", message: error });
      })
      .finally(() => setCatalogsLoading(false));
  }, [searchTerm, setCatalogs, setCatalogsLoading]);

  const loadCatalogs = (type) =>
    setShowMore({
      ...showMore,
      [type]: !showMore[type],
    });

  return (
    <>
      {notification.type && (
        <Notification
          color={notification.type === "error" ? "danger" : "success"}
          isOpen={isNotificationVisible}
          toggle={onDismissNotification}
        >
          {notification.message}
        </Notification>
      )}
      <Header />
      <div className="px-3 px-md-4 py-1">
        <div className="pt-3 position-relative">
          <SearchInput
            className="unmask"
            autoFocus
            type="search"
            placeholder={"Search Modules"}
            value={searchText}
            onChange={(e) => handleSearch(e.target.value)}
          />
        </div>
        {catalogsLoading ? (
          <CoreContainer>
            <Spinner>Loading...</Spinner>
          </CoreContainer>
        ) : Object.keys(catalogs).length === 0 ? (
          <Card className="d-flex justify-content-center align-items-center empty px-3 mt-3">
            {searchParams.get("search") && (
              <span>No modules found! Try a different keyword.</span>
            )}
            {!searchParams.get("search") && <span>Type to search modules</span>}
          </Card>
        ) : (
          <CatalogsContainer className="modules-container">
            {Object.entries(catalogs).map(([type, products]) => (
              <div key={type}>
                {type && <p className="product-type ms-1 fw-bold mb-0">{type}</p>}
                <CardGroup className="modules-listing row">
                  {(() => {
                    const filteredProducts =
                      !showMore[type] && !searchText
                        ? products.slice(0, 6)
                        : products;

                    return filteredProducts.map((product, index) => {
                      return (
                        <Catalog
                          key={index}
                          images={product.images}
                          name={product.name}
                          sku={product.sku}
                          id={product.id}
                        />
                      );
                    });
                  })()}
                </CardGroup>
                {!searchTerm && (
                  <div className="mt-3 d-flex justify-content-center">
                    <Button
                      className="bg-white rounded-1"
                      style={{ border: "1px solid #999", color: "#666666" }}
                      onClick={() => loadCatalogs(type)}
                    >
                      {showMore[type] ? "Show Less" : "Show More"}
                    </Button>
                  </div>
                )}
              </div>
            ))}
          </CatalogsContainer>
        )}
      </div>
    </>
  );
};

export default Catalogs;
